import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoleculeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Symbols",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		fillOpacity: .84,
		children: /* @__PURE__ */ _jsx("g", {
			id: "Icons-(Platform)/molecule_24px",
			fill: "#000000",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M12,4 L16.7647059,6.64705882 L16.764,10.646 L21,13 L21,18.2941176 L16.2352941,20.9411765 L12,18.588 L7.76470588,20.9411765 L3,18.2941176 L3,13 L7.235,10.646 L7.23529412,6.64705882 L12,4 Z M16.2352941,12.3911765 L13.3028302,14.0182353 L13.3028302,17.2741176 L16.2352941,18.9011765 L19.1659241,17.2741176 L19.1659241,14.0182353 L16.2352941,12.3911765 Z M7.76470588,12.3911765 L4.83224198,14.0182353 L4.83224198,17.2741176 L7.76470588,18.9011765 L10.6953358,17.2741176 L10.6953358,14.0182353 L7.76470588,12.3911765 Z M12,6.03823529 L9.0675361,7.66529412 L9.0675361,10.9211765 L12,12.5482353 L14.93063,10.9211765 L14.93063,7.66529412 L12,6.03823529 Z",
				id: "icon"
			})
		})
	})
});
export default SvgMoleculeIcon;
